var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlbLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "PLB_Logo-white",
    width: 130.489,
    height: 33.169,
    viewBox: "0 0 130.489 33.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-2{isolation:isolate}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLB_logo_identity_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20432",
    d: "M222.412 64.013a5.255 5.255 0 0 0-4.033 1.626 5.5 5.5 0 0 0-1.68 4v8.974h1.932v-4.7a5.355 5.355 0 0 0 3.454 1.373h.216a5.224 5.224 0 0 0 3.8-1.613 5.628 5.628 0 0 0 1.677-4.056 5.517 5.517 0 0 0-1.566-3.91 5.268 5.268 0 0 0-3.8-1.71m3.4 5.713a3.547 3.547 0 0 1-1.088 2.572 3.429 3.429 0 0 1-2.539 1.055 3.223 3.223 0 0 1-2.459-1.049 3.637 3.637 0 0 1-1.06-2.546 3.717 3.717 0 0 1 1.057-2.714 3.246 3.246 0 0 1 2.454-1.073h.2a3.318 3.318 0 0 1 2.446 1.168 3.616 3.616 0 0 1 .993 2.6",
    className: "cls-1",
    transform: "translate(-172.828 -56.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20433",
    d: "M268.785 64.624a3.682 3.682 0 0 0-.818.6v-.805h-1.877v10.8h2.034V68.8a2.781 2.781 0 0 1 .3-1.415 3.329 3.329 0 0 1 .736-.772 2.2 2.2 0 0 1 1.353-.45h.3v-1.937h-.3a3.4 3.4 0 0 0-1.721.409",
    className: "cls-1",
    transform: "translate(-209.515 -56.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4424",
    d: "M0 0H1.95V10.795H0z",
    className: "cls-1",
    transform: "translate(63.175 7.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20434",
    d: "M314.93 71.453a3.656 3.656 0 0 1-3.3 1.767 3.75 3.75 0 0 1-3.784-3.714 3.493 3.493 0 0 1 1.209-2.654 3.6 3.6 0 0 1 2.545-1.062h.064a3.6 3.6 0 0 1 3.246 1.87l.087.149h2.179l-.386-.875a5.028 5.028 0 0 0-2.014-2.209 5.749 5.749 0 0 0-3.066-.885h-.1a5.818 5.818 0 0 0-4.087 1.713 5.527 5.527 0 0 0-.1 7.817c.051.054.105.105.159.157a5.787 5.787 0 0 0 4.033 1.638h.062a5.521 5.521 0 0 0 5.175-3.086l.358-.772h-2.186z",
    className: "cls-1",
    transform: "translate(-239.051 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20435",
    d: "M360 63.84h-.35a5.329 5.329 0 0 0-3.83 1.633 5.628 5.628 0 0 0-.1 7.973c.046.049.093.1.141.141a5.37 5.37 0 0 0 3.838 1.6h.077a5.581 5.581 0 0 0 3.189-1.029 5.5 5.5 0 0 0 2.058-2.76l.136-.4H363.1l-.082.172a3.279 3.279 0 0 1-3.179 2.058 3.6 3.6 0 0 1-2.495-.911 3.416 3.416 0 0 1-1.15-2.009h9.1v-1.026a5.185 5.185 0 0 0-1.543-3.642 5.586 5.586 0 0 0-3.75-1.8m3.241 4.591h-7.029a3.459 3.459 0 0 1 1.178-1.8 3.773 3.773 0 0 1 4.7.031 3.647 3.647 0 0 1 1.147 1.767",
    className: "cls-1",
    transform: "translate(-274.896 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4425",
    d: "M0 0H1.968V14.386H0z",
    className: "cls-1",
    transform: "translate(91.733 4.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20436",
    d: "M421.8 63.983a5.17 5.17 0 0 0-4.015 1.626 5.7 5.7 0 0 0-.131 7.948 5.27 5.27 0 0 0 3.827 1.7h.216a5.214 5.214 0 0 0 3.8-1.613 5.635 5.635 0 0 0 .131-7.927 5.324 5.324 0 0 0-3.827-1.731m3.418 5.548a3.681 3.681 0 0 1-1.078 2.714 3.174 3.174 0 0 1-2.431 1.07h-.2a3.328 3.328 0 0 1-2.446-1.152 3.6 3.6 0 0 1-.975-2.613 3.524 3.524 0 0 1 1.073-2.572 3.344 3.344 0 0 1 2.482-1.055h.072a3.2 3.2 0 0 1 2.423 1.049 3.717 3.717 0 0 1 1.078 2.549",
    className: "cls-1",
    transform: "translate(-320.941 -56.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20437",
    d: "M473.074 71.453a3.663 3.663 0 0 1-3.3 1.767 3.75 3.75 0 0 1-3.784-3.714 3.493 3.493 0 0 1 1.209-2.654 3.6 3.6 0 0 1 2.544-1.062h.064a3.6 3.6 0 0 1 3.246 1.87l.09.149h2.166l-.383-.874a5.041 5.041 0 0 0-2.014-2.209 5.748 5.748 0 0 0-3.066-.885h-.1a5.816 5.816 0 0 0-4.09 1.713 5.522 5.522 0 0 0-.1 7.811q.077.085.162.162a5.769 5.769 0 0 0 4.03 1.638h.064a5.517 5.517 0 0 0 5.172-3.086l.355-.754h-2.184z",
    className: "cls-1",
    transform: "translate(-356.51 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20438",
    d: "M519.714 65.636A5.337 5.337 0 0 0 515.879 64h-.216a5.283 5.283 0 0 0-3.822 1.7 5.5 5.5 0 0 0-1.543 3.91 5.6 5.6 0 0 0 1.68 4.056 5.242 5.242 0 0 0 4.031 1.608 5.342 5.342 0 0 0 3.439-1.373v4.7h1.95v-8.942a5.283 5.283 0 0 0-1.659-4.01m-.322 4.115a3.637 3.637 0 0 1-1.06 2.546 3.261 3.261 0 0 1-2.443 1.049 3.444 3.444 0 0 1-2.554-1.055 3.537 3.537 0 0 1-1.073-2.572 3.619 3.619 0 0 1 .975-2.6 3.375 3.375 0 0 1 2.454-1.168h.193a3.176 3.176 0 0 1 2.43 1.073 3.681 3.681 0 0 1 1.078 2.714",
    className: "cls-1",
    transform: "translate(-390.91 -56.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4426",
    d: "M0 0H1.947V1.95H0z",
    className: "cls-1",
    transform: "translate(63.178 4.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20439",
    d: "M222.412 64.013a5.255 5.255 0 0 0-4.033 1.626 5.5 5.5 0 0 0-1.68 4v8.974h1.932v-4.7a5.355 5.355 0 0 0 3.454 1.373h.216a5.224 5.224 0 0 0 3.8-1.613 5.628 5.628 0 0 0 1.677-4.056 5.517 5.517 0 0 0-1.566-3.91 5.268 5.268 0 0 0-3.8-1.71m3.4 5.713a3.547 3.547 0 0 1-1.088 2.572 3.429 3.429 0 0 1-2.539 1.055 3.223 3.223 0 0 1-2.459-1.049 3.637 3.637 0 0 1-1.06-2.546 3.717 3.717 0 0 1 1.057-2.714 3.246 3.246 0 0 1 2.454-1.073h.2a3.318 3.318 0 0 1 2.446 1.168 3.616 3.616 0 0 1 .993 2.6",
    className: "cls-1",
    transform: "translate(-172.828 -56.61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20440",
    d: "M268.785 64.624a3.682 3.682 0 0 0-.818.6v-.805h-1.877v10.8h2.034V68.8a2.781 2.781 0 0 1 .3-1.415 3.329 3.329 0 0 1 .736-.772 2.2 2.2 0 0 1 1.353-.45h.3v-1.937h-.3a3.4 3.4 0 0 0-1.721.409",
    className: "cls-1",
    transform: "translate(-209.515 -56.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4427",
    d: "M0 0H1.95V10.795H0z",
    className: "cls-1",
    transform: "translate(63.175 7.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20441",
    d: "M314.93 71.453a3.656 3.656 0 0 1-3.3 1.767 3.75 3.75 0 0 1-3.784-3.714 3.493 3.493 0 0 1 1.209-2.654 3.6 3.6 0 0 1 2.545-1.062h.064a3.6 3.6 0 0 1 3.246 1.87l.087.149h2.179l-.386-.875a5.028 5.028 0 0 0-2.014-2.209 5.749 5.749 0 0 0-3.066-.885h-.1a5.818 5.818 0 0 0-4.087 1.713 5.527 5.527 0 0 0-.1 7.817c.051.054.105.105.159.157a5.787 5.787 0 0 0 4.033 1.638h.062a5.521 5.521 0 0 0 5.175-3.086l.358-.772h-2.186z",
    className: "cls-1",
    transform: "translate(-239.051 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20442",
    d: "M360 63.84h-.35a5.329 5.329 0 0 0-3.83 1.633 5.628 5.628 0 0 0-.1 7.973c.046.049.093.1.141.141a5.37 5.37 0 0 0 3.838 1.6h.077a5.581 5.581 0 0 0 3.189-1.029 5.5 5.5 0 0 0 2.058-2.76l.136-.4H363.1l-.082.172a3.279 3.279 0 0 1-3.179 2.058 3.6 3.6 0 0 1-2.495-.911 3.416 3.416 0 0 1-1.15-2.009h9.1v-1.026a5.185 5.185 0 0 0-1.543-3.642 5.586 5.586 0 0 0-3.75-1.8m3.241 4.591h-7.029a3.459 3.459 0 0 1 1.178-1.8 3.773 3.773 0 0 1 4.7.031 3.647 3.647 0 0 1 1.147 1.767",
    className: "cls-1",
    transform: "translate(-274.896 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4428",
    d: "M0 0H1.968V14.386H0z",
    className: "cls-1",
    transform: "translate(91.733 4.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20443",
    d: "M421.8 63.983a5.17 5.17 0 0 0-4.015 1.626 5.7 5.7 0 0 0-.131 7.948 5.27 5.27 0 0 0 3.827 1.7h.216a5.214 5.214 0 0 0 3.8-1.613 5.635 5.635 0 0 0 .131-7.927 5.324 5.324 0 0 0-3.827-1.731m3.418 5.548a3.681 3.681 0 0 1-1.078 2.714 3.174 3.174 0 0 1-2.431 1.07h-.2a3.328 3.328 0 0 1-2.446-1.152 3.6 3.6 0 0 1-.975-2.613 3.524 3.524 0 0 1 1.073-2.572 3.344 3.344 0 0 1 2.482-1.055h.072a3.2 3.2 0 0 1 2.423 1.049 3.717 3.717 0 0 1 1.078 2.549",
    className: "cls-1",
    transform: "translate(-320.941 -56.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20444",
    d: "M473.074 71.453a3.663 3.663 0 0 1-3.3 1.767 3.75 3.75 0 0 1-3.784-3.714 3.493 3.493 0 0 1 1.209-2.654 3.6 3.6 0 0 1 2.544-1.062h.064a3.6 3.6 0 0 1 3.246 1.87l.09.149h2.166l-.383-.874a5.041 5.041 0 0 0-2.014-2.209 5.748 5.748 0 0 0-3.066-.885h-.1a5.816 5.816 0 0 0-4.09 1.713 5.522 5.522 0 0 0-.1 7.811q.077.085.162.162a5.769 5.769 0 0 0 4.03 1.638h.064a5.517 5.517 0 0 0 5.172-3.086l.355-.754h-2.184z",
    className: "cls-1",
    transform: "translate(-356.51 -56.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20445",
    d: "M519.714 65.636A5.337 5.337 0 0 0 515.879 64h-.216a5.283 5.283 0 0 0-3.822 1.7 5.5 5.5 0 0 0-1.543 3.91 5.6 5.6 0 0 0 1.68 4.056 5.242 5.242 0 0 0 4.031 1.608 5.342 5.342 0 0 0 3.439-1.373v4.7h1.95v-8.942a5.283 5.283 0 0 0-1.659-4.01m-.322 4.115a3.637 3.637 0 0 1-1.06 2.546 3.261 3.261 0 0 1-2.443 1.049 3.444 3.444 0 0 1-2.554-1.055 3.537 3.537 0 0 1-1.073-2.572 3.619 3.619 0 0 1 .975-2.6 3.375 3.375 0 0 1 2.454-1.168h.193a3.176 3.176 0 0 1 2.43 1.073 3.681 3.681 0 0 1 1.078 2.714",
    className: "cls-1",
    transform: "translate(-390.91 -56.61)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5543",
    className: "cls-2",
    transform: "translate(57.1 21.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5541",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20446",
    d: "M268.13 128.464v-7.734h3.825v.772h-3.086v2.708h3.086v.772h-3.086v3.483z",
    className: "cls-1",
    transform: "translate(-268.13 -120.73)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5542",
    className: "cls-2",
    transform: "translate(4.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20447",
    d: "M286 130.472a3.061 3.061 0 0 1 .882-2.2 2.806 2.806 0 0 1 2.089-.913 3.061 3.061 0 0 1 3.061 3.038 3.133 3.133 0 0 1-.877 2.232 2.829 2.829 0 0 1-2.124.923 2.881 2.881 0 0 1-2.15-.905 3.015 3.015 0 0 1-.881-2.175zm.787 0a2.369 2.369 0 0 0 .643 1.692 2.109 2.109 0 0 0 1.6.682 2.057 2.057 0 0 0 1.577-.682 2.4 2.4 0 0 0 .638-1.7 2.348 2.348 0 0 0-.646-1.7 2.181 2.181 0 0 0-1.638-.666 2.022 2.022 0 0 0-1.543.684 2.39 2.39 0 0 0-.646 1.685z",
    className: "cls-1",
    transform: "translate(-285.998 -125.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20448",
    d: "M313.532 133.679h-.772v-5.844h.707v.674a1.9 1.9 0 0 1 .6-.568 1.659 1.659 0 0 1 .772-.19v.813a1.445 1.445 0 0 0-1.011.422 1.776 1.776 0 0 0-.306 1.165z",
    className: "cls-1",
    transform: "translate(-305.877 -125.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20449",
    d: "M335.788 120.73h1.44a3.062 3.062 0 0 1 1.929.5 2.195 2.195 0 0 1 .409 2.451 1.6 1.6 0 0 1-.622.617 2 2 0 0 1 .941.73 2.032 2.032 0 0 1 .314 1.15 2.151 2.151 0 0 1-.651 1.731 3.144 3.144 0 0 1-2.058.553h-1.71zm.728.738v2.6h.458a2.9 2.9 0 0 0 1.574-.311 1.144 1.144 0 0 0 .45-1.029 1.1 1.1 0 0 0-.437-.967 2.445 2.445 0 0 0-1.392-.306zm0 3.344v2.917h1.067a2.223 2.223 0 0 0 1.391-.358 1.312 1.312 0 0 0 .448-1.093 1.332 1.332 0 0 0-.455-1.1 2.207 2.207 0 0 0-1.384-.363z",
    className: "cls-1",
    transform: "translate(-322.976 -120.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20450",
    d: "M356.8 128.08h.738v3.1a2.806 2.806 0 0 0 .388 1.692 1.519 1.519 0 0 0 1.273.5 1.852 1.852 0 0 0 .887-.2 1.574 1.574 0 0 0 .617-.594 1.7 1.7 0 0 0 .19-.538 6.8 6.8 0 0 0 .059-1.083v-2.877h.749v5.844h-.736v-.633a2.1 2.1 0 0 1-.759.6 2.516 2.516 0 0 1-1.016.185 2.224 2.224 0 0 1-1.821-.682 3.613 3.613 0 0 1-.558-2.266z",
    className: "cls-1",
    transform: "translate(-338.589 -126.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20451",
    d: "M379 131.647h.772v.023a1.32 1.32 0 0 0 .314.905.983.983 0 0 0 .772.358 1.029 1.029 0 0 0 .733-.275.919.919 0 0 0 .293-.7.962.962 0 0 0-.232-.674 2.152 2.152 0 0 0-.836-.478 2.966 2.966 0 0 1-1.271-.707 1.474 1.474 0 0 1-.3-.967 1.543 1.543 0 0 1 .5-1.163 1.664 1.664 0 0 1 1.2-.478 1.646 1.646 0 0 1 1.191.424 1.677 1.677 0 0 1 .473 1.186h-.782a.946.946 0 0 0-.257-.643.9.9 0 0 0-.646-.229.831.831 0 0 0-.612.257.843.843 0 0 0-.244.615.879.879 0 0 0 .1.437.947.947 0 0 0 .337.322 2.508 2.508 0 0 0 .617.257 5.722 5.722 0 0 1 .545.183 1.572 1.572 0 0 1 1.062 1.608 1.644 1.644 0 0 1-.514 1.25 1.878 1.878 0 0 1-1.335.494 1.713 1.713 0 0 1-1.322-.54 2.143 2.143 0 0 1-.558-1.465z",
    className: "cls-1",
    transform: "translate(-355.079 -125.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20452",
    d: "M397.746 121.936H397v-1.206h.748zm-.746 6.528v-5.844h.748v5.844z",
    className: "cls-1",
    transform: "translate(-368.45 -120.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20453",
    d: "M404.58 127.745h.728v.664a2.186 2.186 0 0 1 .8-.589 2.637 2.637 0 0 1 1.029-.19 2.67 2.67 0 0 1 1.145.237 1.914 1.914 0 0 1 .795.687 2.135 2.135 0 0 1 .288.736 6.521 6.521 0 0 1 .087 1.245v3.056h-.738v-3.272a2.334 2.334 0 0 0-.4-1.5 1.537 1.537 0 0 0-1.265-.468 1.883 1.883 0 0 0-.9.206 1.52 1.52 0 0 0-.61.586 1.654 1.654 0 0 0-.193.545 6.643 6.643 0 0 0-.057 1.065v2.842h-.728z",
    className: "cls-1",
    transform: "translate(-374.072 -125.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20454",
    d: "M433.009 130.761h-5.275a2.271 2.271 0 0 0 .689 1.543 2.171 2.171 0 0 0 1.543.586 2.137 2.137 0 0 0 1.186-.34 2.25 2.25 0 0 0 .813-.952h.849a3.308 3.308 0 0 1-1.134 1.489 2.829 2.829 0 0 1-1.69.514 2.9 2.9 0 0 1-2.158-.908 3.192 3.192 0 0 1-.018-4.388 2.976 2.976 0 0 1 2.207-.872 2.78 2.78 0 0 1 2.148.908A3.344 3.344 0 0 1 433 130.7zm-.828-.653a2.631 2.631 0 0 0-.772-1.469 2.191 2.191 0 0 0-1.482-.491 2.058 2.058 0 0 0-1.44.53 2.289 2.289 0 0 0-.723 1.43z",
    className: "cls-1",
    transform: "translate(-390.695 -125.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20455",
    d: "M452.409 131.647h.772v.023a1.333 1.333 0 0 0 .314.905.988.988 0 0 0 .772.358 1.029 1.029 0 0 0 .733-.275.926.926 0 0 0 .291-.7.962.962 0 0 0-.232-.674 2.153 2.153 0 0 0-.836-.478 3 3 0 0 1-1.271-.707 1.471 1.471 0 0 1-.3-.967 1.543 1.543 0 0 1 .5-1.163 1.675 1.675 0 0 1 1.209-.478 1.638 1.638 0 0 1 1.188.424 1.666 1.666 0 0 1 .473 1.186h-.8a.946.946 0 0 0-.257-.643.892.892 0 0 0-.646-.229.82.82 0 0 0-.61.257.833.833 0 0 0-.244.615.88.88 0 0 0 .1.437.915.915 0 0 0 .334.322 2.492 2.492 0 0 0 .62.257c.27.082.45.141.543.183a1.572 1.572 0 0 1 1.062 1.608 1.644 1.644 0 0 1-.514 1.25 1.87 1.87 0 0 1-1.335.494 1.718 1.718 0 0 1-1.322-.54 2.152 2.152 0 0 1-.544-1.465z",
    className: "cls-1",
    transform: "translate(-409.607 -125.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20456",
    d: "M468.868 131.648h.772v.023a1.332 1.332 0 0 0 .314.905.988.988 0 0 0 .772.358 1.029 1.029 0 0 0 .733-.275.916.916 0 0 0 .291-.7.972.972 0 0 0-.229-.674 2.165 2.165 0 0 0-.839-.478 2.941 2.941 0 0 1-1.268-.707 1.458 1.458 0 0 1-.3-.967 1.543 1.543 0 0 1 .5-1.163 1.675 1.675 0 0 1 1.2-.478 1.649 1.649 0 0 1 1.191.424 1.677 1.677 0 0 1 .471 1.186h-.8a.934.934 0 0 0-.257-.643.893.893 0 0 0-.646-.229.82.82 0 0 0-.61.257.834.834 0 0 0-.244.615.879.879 0 0 0 .1.437.915.915 0 0 0 .334.322 2.49 2.49 0 0 0 .62.257 5.6 5.6 0 0 1 .543.183 1.577 1.577 0 0 1 1.065 1.608 1.646 1.646 0 0 1-.527 1.25 1.867 1.867 0 0 1-1.332.494 1.721 1.721 0 0 1-1.325-.54 2.153 2.153 0 0 1-.527-1.466z",
    className: "cls-1",
    transform: "translate(-421.832 -125.752)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20457",
    d: "M120.893 80a4.476 4.476 0 0 0-.275-.584l1.286-.728a6.213 6.213 0 0 1 .365.772zm-.653-1.152a4.768 4.768 0 0 0-.432-.478l1.029-1.07a5.587 5.587 0 0 1 .574.635zm-.957-.913a4.652 4.652 0 0 0-.553-.334l.679-1.322a6.23 6.23 0 0 1 .733.442z",
    className: "cls-1",
    transform: "translate(-100.057 -65.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20458",
    d: "M104.293 86.737a3.292 3.292 0 1 1-4.074-2.253 3.287 3.287 0 0 1 4.072 2.248",
    className: "cls-1",
    transform: "translate(-84.537 -71.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20459",
    d: "M126.4 96.871l.98.98a5.929 5.929 0 0 0 .929-3.195 5.763 5.763 0 0 0-.064-.867l-1.328.211a4.63 4.63 0 0 1-.514 2.87",
    className: "cls-1",
    transform: "translate(-105.754 -78.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20460",
    d: "M95.481 84.115a4.614 4.614 0 1 1-.949-8.606l.35-1.286a6.034 6.034 0 0 0-1.471-.183 5.962 5.962 0 1 0 3.058 11.078z",
    className: "cls-1",
    transform: "translate(-76.818 -64.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4429",
    d: "M0 0H1.343V6.572H0z",
    className: "cls-1",
    transform: "rotate(-45.01 29.226 -11.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20461",
    d: "M77.826 42.554V35.27a16.536 16.536 0 0 0-10.466 4.277l5.031 5.253a9.26 9.26 0 0 1 5.435-2.251z",
    className: "cls-1",
    transform: "translate(-61.899 -35.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20462",
    d: "M141.106 68.138h7.276a16.521 16.521 0 0 0-4-10.448l-5.268 5.039a9.26 9.26 0 0 1 1.992 5.409z",
    className: "cls-1",
    transform: "translate(-115.195 -51.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20463",
    d: "M119 45.088l5.26-5.031a16.551 16.551 0 0 0-11.01-4.787v7.284a9.29 9.29 0 0 1 5.75 2.534z",
    className: "cls-1",
    transform: "translate(-95.986 -35.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20464",
    d: "M139.508 103.51a9.308 9.308 0 0 1-2.508 5.443l5.028 5.257a16.556 16.556 0 0 0 4.771-10.7z",
    className: "cls-1",
    transform: "translate(-113.628 -85.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20465",
    d: "M118.368 128.19a9.293 9.293 0 0 1-5.118 1.986v7.284a16.51 16.51 0 0 0 10.155-4.007z",
    className: "cls-1",
    transform: "translate(-95.986 -104.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20466",
    d: "M71.75 127.19l-5.28 5.039a16.538 16.538 0 0 0 10.695 4.488v-7.284a9.3 9.3 0 0 1-5.415-2.243z",
    className: "cls-1",
    transform: "translate(-61.238 -103.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20467",
    d: "M53.524 103.51H46.24a16.531 16.531 0 0 0 4.26 10.175l5.26-5.031a9.272 9.272 0 0 1-2.236-5.144z",
    className: "cls-1",
    transform: "translate(-46.212 -85.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20468",
    d: "M55.675 60.8l-5.041-5.26a16.556 16.556 0 0 0-4.5 11h7.282a9.275 9.275 0 0 1 2.259-5.74z",
    className: "cls-1",
    transform: "translate(-46.13 -50.326)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlbLogoWhite);
export default __webpack_public_path__ + "static/media/plb-logo-white.52bfdc41e005c546eb336e56599d397d.svg";
export { ForwardRef as ReactComponent };